import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger, SpecraButton, SpecraDataTable, SpecraInlineBanner, SpecraOverlayDialog } from '@mono/ui-components';
import { Testids } from '@mono/ui-selectors';
import { useState } from 'react';
import { useArchiveSeatRound } from '../hooks/useLandscapeSeats';
import { SeatRoundForm } from './SeatRoundForm';
export function SeatRoundsDialog({ seat, onClose }) {
    const [editing, setEditing] = useState();
    const [archiving, setArchiving] = useState();
    const [error, setError] = useState('');
    const archive = useArchiveSeatRound();
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs(SpecraOverlayDialog, {
                open: true,
                title: `Rounds for ${seat.name}`,
                testId: Testids.seatAdmin.roundsDialog,
                onOpenChange: (v)=>{
                    if (!v) onClose();
                },
                footerProps: {
                    cancelLabel: 'Close',
                    onCancel: onClose
                },
                children: [
                    error && /*#__PURE__*/ _jsx(SpecraInlineBanner, {
                        tone: "danger",
                        "data-testid": Testids.seatAdmin.error,
                        children: error
                    }),
                    /*#__PURE__*/ _jsx(SpecraButton, {
                        "data-testid": Testids.seatAdmin.addRound,
                        onClick: ()=>setEditing('new'),
                        children: "Add round"
                    }),
                    /*#__PURE__*/ _jsx(SpecraDataTable, {
                        rows: seat.rounds,
                        getRowId: (r)=>r.id,
                        columns: [
                            {
                                header: '#',
                                cell: (r)=>r.roundIndex
                            },
                            {
                                header: 'Status',
                                cell: (r)=>r.status
                            },
                            {
                                header: 'Holder',
                                cell: (r)=>r.holderLabel || r.holderKind
                            },
                            {
                                header: 'Contract',
                                cell: (r)=>r.label || r.registryContractId || '—'
                            },
                            {
                                header: 'PoP',
                                cell: (r)=>`${r.popStart || '—'} – ${r.popEnd || '—'}`
                            },
                            {
                                header: 'Value',
                                cell: (r)=>(Number(r.valueCents) / 100).toLocaleString('en-US', {
                                        style: 'currency',
                                        currency: 'USD'
                                    })
                            },
                            {
                                header: 'Source',
                                cell: (r)=>r.sourceNote || r.sourceBasis
                            },
                            {
                                header: 'Actions',
                                cell: (r)=>/*#__PURE__*/ _jsxs(DropdownMenu, {
                                        children: [
                                            /*#__PURE__*/ _jsx(DropdownMenuTrigger, {
                                                asChild: true,
                                                children: /*#__PURE__*/ _jsx(SpecraButton, {
                                                    variant: "secondary",
                                                    size: "xs",
                                                    "aria-label": `Actions for round ${r.roundIndex}`,
                                                    children: "Actions"
                                                })
                                            }),
                                            /*#__PURE__*/ _jsxs(DropdownMenuContent, {
                                                children: [
                                                    /*#__PURE__*/ _jsx(DropdownMenuItem, {
                                                        onSelect: ()=>setEditing(r),
                                                        children: "Edit"
                                                    }),
                                                    /*#__PURE__*/ _jsx(DropdownMenuItem, {
                                                        onSelect: ()=>setArchiving(r),
                                                        children: "Archive round"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                            }
                        ]
                    })
                ]
            }),
            editing && /*#__PURE__*/ _jsx(SeatRoundForm, {
                seat: seat,
                round: editing === 'new' ? undefined : editing,
                onClose: ()=>setEditing(undefined)
            }),
            archiving && /*#__PURE__*/ _jsx(SpecraOverlayDialog, {
                open: true,
                title: "Archive round?",
                testId: Testids.seatAdmin.archiveDialog,
                description: "This round will be removed from seat history.",
                onOpenChange: (v)=>{
                    if (!v) setArchiving(undefined);
                },
                footerProps: {
                    cancelLabel: 'Cancel',
                    onCancel: ()=>setArchiving(undefined),
                    confirmLabel: 'Archive round',
                    loading: archive.isPending,
                    onConfirm: async ()=>{
                        try {
                            await archive.mutateAsync({
                                roundId: archiving.id
                            });
                            setArchiving(undefined);
                        } catch (e) {
                            setError(e instanceof Error ? e.message : String(e));
                            setArchiving(undefined);
                        }
                    }
                },
                children: null
            })
        ]
    });
}
